export default function IntroSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
          {/* Left - Text */}
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3 block">
              Why ACbuyspreadsheet
            </span>
            <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-6 leading-tight">
              What Exactly Is <strong>ACbuyspreadsheet</strong> and Why It Changes Everything
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed text-base">
              <p>
                <strong>ACbuyspreadsheet</strong> is not just another shopping tool — it is a complete 
                <strong> spreadsheet buying system</strong> designed to bring structure and clarity to 
                your purchasing decisions. Instead of relying on scattered browser tabs, messy bookmarks, 
                and forgotten wishlists, the acbuyspreadsheet approach consolidates everything into one 
                clean, organized spreadsheet-based workflow.
              </p>
              <p>
                The core philosophy behind <strong>acbuyspreadsheet</strong> is simple: when you can see 
                every product, every category, and every price comparison laid out in a structured format, 
                you make faster, smarter, and more confident buying decisions. No more second-guessing 
                whether you got the best deal. No more losing track of items you intended to purchase. 
                The acbuyspreadsheet system acts as your centralized command center for all things shopping.
              </p>
              <p>
                What makes this <strong>spreadsheet buying system</strong> uniquely powerful is its 
                combination of accessibility and depth. Beginners can jump in and start organizing their 
                purchases within minutes, while experienced users can build elaborate tracking sheets 
                with categories, price alerts, and comparison metrics. The <strong>acbuyspreadsheet</strong> 
                methodology has already helped thousands of users transform chaotic shopping habits into 
                streamlined, efficient purchasing workflows.
              </p>
            </div>
          </div>

          {/* Right - Feature Cards */}
          <div className="flex flex-col gap-5">
            <div className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className="ri-speed-up-line text-accent-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold font-heading text-foreground-900 mb-1">Faster Order Tracking</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  The <strong>acbuyspreadsheet</strong> system cuts research time by up to 70%. 
                  Every product link, price, and category is already mapped out in an organized spreadsheet structure.
                </p>
              </div>
            </div>

            <div className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className="ri-database-2-line text-primary-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold font-heading text-foreground-900 mb-1">Structured Spreadsheet System</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Unlike chaotic manual browsing, <strong>acbuyspreadsheet</strong> provides a 
                  logical, hierarchical structure where every category nests neatly under a clear organizational framework.
                </p>
              </div>
            </div>

            <div className="flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-secondary-100 flex items-center justify-center">
                <i className="ri-shield-check-line text-secondary-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold font-heading text-foreground-900 mb-1">Reduced Buying Errors</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  With <strong>acbuyspreadsheet</strong>, duplicate purchases and missed deals become a thing 
                  of the past. The system's visual layout ensures nothing slips through the cracks.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}